/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {HeliportEnvironment} from "./heliportEnvironment.zod";
import {RegisteredCompanyInput} from "./registeredCompanyInput.zod";

export const UpdateClientRequest = zod.object({
  company: RegisteredCompanyInput,
  environments: zod.array(HeliportEnvironment).min(1),
  logoUrl: zod.string().optional(),
});

export type UpdateClientRequest = zod.input<typeof UpdateClientRequest>;
export type UpdateClientRequestOutput = zod.output<typeof UpdateClientRequest>;
